<template>
  <el-input
    :model-value="modelValue"
    :placeholder="placeholder"
    clearable
    class="search-input"
    :style="{ width }"
    @update:model-value="onInput"
    @keyup.enter="emitSearch(modelValue)"
    @clear="emitSearch('')"
  >
    <template #prefix>
      <el-icon><Search /></el-icon>
    </template>
  </el-input>
</template>

<script setup lang="ts">
import { onUnmounted } from 'vue'
import { debounce } from 'lodash-es'
import { Search } from '@element-plus/icons-vue'

const props = withDefaults(
  defineProps<{
    modelValue: string
    placeholder?: string
    width?: string
    /** Set to 0 to emit `search` only on Enter and clear. */
    debounceMs?: number
  }>(),
  { placeholder: 'Cerca…', width: '260px', debounceMs: 350 }
)

const emit = defineEmits<{
  'update:modelValue': [value: string]
  search: [value: string]
}>()

const emitSearch = (value: string) => emit('search', value)
const debouncedSearch = debounce(emitSearch, props.debounceMs)

const onInput = (value: string) => {
  emit('update:modelValue', value)
  if (props.debounceMs > 0) debouncedSearch(value)
}

onUnmounted(() => debouncedSearch.cancel())
</script>

<style scoped>
.search-input {
  flex: 1;
  min-width: 180px;
  max-width: 100%;
}
</style>
